var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ins-header'),_c('router-view'),_c('ins-footer'),(_vm.isMobile)?_c('ins-slide-menu',{attrs:{"direction":'top'}},[_c('ins-menu-layout')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }